import { PutObjectCommand, DeleteObjectCommand } from '@aws-sdk/client-s3';
import { s3 } from 'utils/aws';

const bucketName =
  'statefulresourcesstack-contentartifactbucketa50c39-edoymcaagsm6';

export const useS3Upload = () => {
  const uploadToS3 = async (file: File, path: string) => {
    try {
      const command = new PutObjectCommand({
        Bucket: bucketName,
        Key: path,
        Body: file,
        ContentType: file.type,
      });

      await s3.send(command);

      console.log('upload file to S3: ', { bucket: bucketName, path });

      // Construct the S3 URL since SDK v3 doesn't return it directly
      return `https://${bucketName}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${path}`;
    } catch (error) {
      console.error('Error uploading to S3:', error);
      throw error;
    }
  };

  return { uploadToS3 };
};

export const deleteFromS3 = async (url: string) => {
  try {
    // Extract path from full URL
    // URL format: https://bucketname.s3.region.amazonaws.com/assignments/aid/aid_qp
    const urlParts = url.split('/');
    const path = urlParts.slice(3).join('/'); // Skip protocol, domain, and bucket name

    if (!path) {
      throw new Error('Invalid S3 URL format');
    }

    console.log('Deleting S3 file:', { bucket: bucketName, path });

    const command = new DeleteObjectCommand({
      Bucket: bucketName,
      Key: path,
    });

    await s3.send(command);
  } catch (error) {
    console.error('Error deleting from S3:', error);
    throw error;
  }
};
